import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { useTheme } from '../contexts/ThemeContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isDark } = useTheme();

  const quickLinks = [
    { label: 'Beranda', id: 'hero' },
    { label: 'Layanan', id: 'services' },
    { label: 'Tentang', id: 'about' },
    { label: 'Portfolio', id: 'portfolio' },
    { label: 'Testimoni', id: 'testimonials' },
    { label: 'Kontak', id: 'contact' }
  ];

  const services = [
    'WaterProffing',
    'Maquete',
    'Interior Design',
    'Electrical',
    'Rope Access Technic',
    'Architecture'
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className={isDark ? 'bg-slate-950 text-gray-300' : 'bg-gray-100 text-slate-700'}>
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold text-orange-500 mb-4">
              PT. HARKAT BANGKIT JAYA
            </h3>
            <p className={`${isDark ? 'text-gray-400' : 'text-slate-600'} mb-6 leading-relaxed`}>
              Solusi konstruksi profesional dengan standar kualitas terbaik untuk masa depan yang lebih baik.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className={`w-10 h-10 ${isDark ? 'bg-slate-800 text-gray-300' : 'bg-white text-slate-700 shadow-md'} hover:bg-orange-600 hover:text-white rounded-lg flex items-center justify-center transition-all duration-300`}
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className={`w-10 h-10 ${isDark ? 'bg-slate-800 text-gray-300' : 'bg-white text-slate-700 shadow-md'} hover:bg-orange-600 hover:text-white rounded-lg flex items-center justify-center transition-all duration-300`}
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className={`w-10 h-10 ${isDark ? 'bg-slate-800 text-gray-300' : 'bg-white text-slate-700 shadow-md'} hover:bg-orange-600 hover:text-white rounded-lg flex items-center justify-center transition-all duration-300`}
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className={`${isDark ? 'text-white' : 'text-slate-900'} font-bold text-lg mb-4`}>Menu Cepat</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className={`${isDark ? 'text-gray-400' : 'text-slate-600'} hover:text-orange-500 transition-colors duration-200`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className={`${isDark ? 'text-white' : 'text-slate-900'} font-bold text-lg mb-4`}>Layanan</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className={`${isDark ? 'text-gray-400' : 'text-slate-600'} hover:text-orange-500 transition-colors duration-200`}
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className={`${isDark ? 'text-white' : 'text-slate-900'} font-bold text-lg mb-4`}>Kontak</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-orange-500 flex-shrink-0 mt-1" size={20} />
                <span className={`${isDark ? 'text-gray-400' : 'text-slate-600'} leading-relaxed`}>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-orange-500 flex-shrink-0" size={20} />
                <a
                  href={companyInfo.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${isDark ? 'text-gray-400' : 'text-slate-600'} hover:text-orange-500 transition-colors`}
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="text-orange-500 flex-shrink-0 mt-1" size={20} />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className={`${isDark ? 'text-gray-400' : 'text-slate-600'} hover:text-orange-500 transition-colors break-all`}
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className={`border-t ${isDark ? 'border-slate-800' : 'border-gray-200'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className={`${isDark ? 'text-gray-400' : 'text-slate-500'} text-sm`}>
              © {currentYear} PT. Harkat Bangkit Jaya. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <button className={`${isDark ? 'text-gray-400' : 'text-slate-500'} hover:text-orange-500 transition-colors`}>
                Created by <a href="https://devaq.id/">Devaq Webdevloper</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
